
import { requiredRule } from '@/helpers/validation/requiredRule';
import { PriceListProduct } from '@/model/PriceListProduct';
import { isEqual } from 'lodash';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import PriceInput from './PriceInput.vue';

@Component({
    components: {
        PriceInput,
    },
})
export default class Product extends Vue {
    @Prop({
        required: true,
    })
    value!: PriceListProduct|null;
    @Prop({
        required: true,
    })
    global!: boolean;
    currentValue: {
        id?: string;
        name: string;
        price: number|null
    } = {
        name: '',
        price: null
    };

    get nameRules() {
        return this.isEmpty ? [] : [
            requiredRule,
            (v: string) => v.length > 32 ? 'Maksymalnie 32 znaki' : true,
            (name: string) => this.allNames.filter(otherName => otherName === name).length > 1 ? 'Nazwa produktu musi być unikalna' : true
        ];
    }

    get priceRules() {
        return this.isEmpty ? [] : [ requiredRule ];
    }

    @Prop({
        type: Array,
        required: true,
    })
    allNames!: string[];

    @Watch('value', {
        immediate: true,
    })
    valueChanged(v: PriceListProduct|null) {
        if (isEqual(v?.getData(), { ...this.currentValue, global: this.global })) {
            return;
        }

        if (v) {
            this.currentValue = {
                id: v.id,
                name: v.name,
                price: v.price
            };
        } else {
            this.currentValue = {
                name: '',
                price: null
            };
        }
    }

    @Watch('currentValue', {
        deep: true,
    })
    currentValueChanged() {
        this.$emit('input', new PriceListProduct(
            this.currentValue.name,
            this.currentValue.price!,
            this.global,
            this.currentValue.id,
        ));
    }

    get isEmpty() {
        return !this.value && !this.currentValue.name && !this.currentValue.price;
    }

    validate() {
        return (this.$refs.inputRef as any).validate(true) && (this.$refs.price as any).validate(true);
    }
}
